import { render, staticRenderFns } from "./WorkMultipleSelectionFilter.vue?vue&type=template&id=5bc84dff"
import script from "./WorkMultipleSelectionFilter.vue?vue&type=script&lang=js"
export * from "./WorkMultipleSelectionFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports